import React from 'react'

import { observer } from 'mobx-react-lite'

import { Checkbox } from 'ziphy-web-shared/basic/lib/simple'

import { $booking } from '@store'

import styles from './SymptomItem.module.scss'

const SymptomItem = ({ symptom }) => {
  return (
    <div
      key={symptom.id}
      className={styles.item}
      onClick={() => $booking.$symptoms.TOGGLE_SELECTED(symptom.id)}
    >
      {symptom.name}
      <Checkbox
        mode={['round', 'small']}
        className={styles.checkbox}
        isChecked={$booking.$symptoms.isSelected(symptom.id)}
        isMulti={true}
      />
    </div>
  )
}

export default observer(SymptomItem)
